<div id="merge-investor-company-modal" class="modal-body text-center">
  <p id="merge-investor-company-title-text" class="title"><strong>MERGE</strong></p>
  <p id="merge-investor-company-content-text">ARE YOU SURE WANT TO MERGE <strong>{{fromInvestorCompany.companyName}}</strong>
    to <strong>{{toInvestorCompany.companyName}}</strong> ?</p>
  <button id="merge-investor-company-cancel-button" type="button" class="btn btn-secondary mt-1" (click)="cancel()">CANCEL</button>
  <button id="merge-investor-company-confirm-button" type="button" class="btn btn-primary ml-2 mt-1" (click)="confirm()">CONFIRM</button>
</div>
